import request from '@utils/request'
import configRequest from "@src/config/request";
import { getLocalStorage, setLocalStorage } from "@utils/localStorage";

export const state = {
  tempCart: getLocalStorage('site.cart.info') || null,
};

export const getters = {};

export const mutations = {
  SET_TEMP_CART(state, newValue) {
    state.tempCart = newValue;
    setLocalStorage('site.cart.info', newValue);
  },
};

export const actions = {

  /**
   * 取得購物車
   * @param commit
   * @param mockType
   * @returns {*}
   */
  fetchCart({ commit }, { mockType } = {}) {
    let fetchCartURL = '/cart';

    const isMockApi = this._vm.$apiPath.indexOf('mock') !== -1;

    if(isMockApi) {
      if(mockType === 'reservation') {
        fetchCartURL = '/cart';
      }
      if(mockType === 'deduct') {
        fetchCartURL = '/cartdeduct';
      }
      if(mockType === 'prepaid') {
        fetchCartURL = '/cartprepaidtest';
      }
    }

    return request
      .get(fetchCartURL, {
        ...configRequest,
        name: 'fetchCart'
      })
  },

  /**
   * 加入購物車
   * @param commit
   * @param prepaidAlias
   * @param prepaidOrderUuid
   * @param inventoryAlias
   * @param params
   * @param petId
   * @returns {*}
   */
  storeCart({ commit }, {
    prepaidAlias,
    prepaidOrderUuid,
    inventoryAlias,
    params,
    petId,
    depositUuid,
    scheduleItemIds,
  } = {}) {
    return request
      .post(`/cart/add`, {
        prepaidAlias,
        prepaidOrderUuid,
        inventoryAlias,
        params,
        petId,
        depositUuid,
        scheduleItemIds,
      }, {
        ...configRequest,
        name: 'storeCart',
        endLoadingDelay: 1500,
      })
  },

  /**
   * 結帳購物車
   * @param commit
   * @param cart
   * @param cartType
   * @param orderId
   * @param mockType
   * @returns {*}
   */
  checkOutCart({ commit }, {
    cart,
    cartType,
    orderId
  } = {}) {
    let checkOutCartURL = '/cart/checkout';

    const isMockApi = this._vm.$apiPath.indexOf('mock') !== -1;

    if(isMockApi) {
      if(cartType === 'reservation') {
        checkOutCartURL = '/cart/checkout';
      }

      if(cartType === 'prepaid') {
        checkOutCartURL = '/cart/checkoutprepaidtest';
      }
    }

    if(orderId) {
      if(cartType === 'prepaid') {
        checkOutCartURL = `/merchant/member/prepaid/order/${orderId}/checkout`

      }

      if(['reservation', 'deposit'].includes(cartType)) {
        checkOutCartURL = `/merchant/member/order/${orderId}/checkout`
      }
    }

    return request
      .post(checkOutCartURL, {
        ...cart
      }, {
        ...configRequest,
        name: 'checkOutCart',
        endLoadingDelay: 2100
      })
  },
  /**
   * 暫存購物車
   * @param commit
   * @param newValue
   */
   setTempCart({ commit }, newValue) {
    commit('SET_TEMP_CART', newValue);
  },

  /**
   * 結帳預約購物車
   * @param commit
   * @param cart
   * @param cartType
   * @param orderId
   * @param mockType
   * @returns {*}
   */
  checkOutContainerCart({ commit }, {
    cart,
    cartType,
    orderId
  } = {}) {
    let checkOutCartURL = '/merchant/member/order/container/checkout';

    const isMockApi = this._vm.$apiPath.indexOf('mock') !== -1;

    if(isMockApi) {
      if(cartType === 'reservation') {
        checkOutCartURL = '/cart/checkout';
      }

      if(cartType === 'prepaid') {
        checkOutCartURL = '/cart/checkoutprepaidtest';
      }
    }

    if(orderId) {
      if(cartType === 'prepaid') {
        checkOutCartURL = `/merchant/member/prepaid/order/${orderId}/checkout`

      }

      if(['reservation', 'deposit', 'daycare'].includes(cartType)) {
        checkOutCartURL = `/merchant/member/order/container/checkout`
      }
    }

    return request
      .post(checkOutCartURL, {
        ...cart
      }, {
        ...configRequest,
        name: 'checkOutCart',
        endLoadingDelay: 2100
      })
  },

  /**
 * 刪除訂單
 * @param ids
 * @returns {*}
 */
  removeOrderList({ commit }, {
    ids
    } = {} ) {
    return request
    .post(`/merchant/member/order/remove`,{
      ids
    }, {
      ...configRequest,
      name: 'removeOrderList',
    })
  }

};